import { makeStyles } from 'tss-react/mui'


const useStyles = makeStyles()((theme) => ({
    container: {
        width: '248px',
        padding: theme.spacing(1),
    },
    divider: {
        margin: theme.spacing(0.75, 0)
    },
}))

export default useStyles